var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500"},on:{"close":_vm.closeDialog},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('LabeledButton',{attrs:{"activator":on,"label":_vm.label,"icon":_vm.icon,"data-nw":_vm.nw}})]}}]),model:{value:(_vm.dialog.show),callback:function ($$v) {_vm.$set(_vm.dialog, "show", $$v)},expression:"dialog.show"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }